import { render, staticRenderFns } from "./OfficeAgentPop.vue?vue&type=template&id=526cbb78&scoped=true"
import script from "./OfficeAgentPop.vue?vue&type=script&lang=js"
export * from "./OfficeAgentPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526cbb78",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('526cbb78')) {
      api.createRecord('526cbb78', component.options)
    } else {
      api.reload('526cbb78', component.options)
    }
    module.hot.accept("./OfficeAgentPop.vue?vue&type=template&id=526cbb78&scoped=true", function () {
      api.rerender('526cbb78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/settle/OfficeAgentPop.vue"
export default component.exports